"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var EventCalendarRow = function EventCalendarRow(_ref) {
  var destinationUrl = _ref.destinationUrl,
      title = _ref.title,
      type = _ref.type,
      startAt = _ref.startAt;
  // TODO move to Event date formatter
  var lang = navigator.language;
  var date = new Date(startAt * 1000);
  var month = date.toLocaleDateString(lang, {
    month: 'short'
  });
  var day = date.getDate();
  return (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(destinationUrl),
    className: "event-calendar-row__url qa-event-calendar-url"
  }, (0, _preact.h)("div", {
    className: "event-calendar-row"
  }, (0, _preact.h)("div", {
    className: "event-calendar-icon-wrapper"
  }, (0, _preact.h)("div", {
    className: "event-calendar-icon-container"
  }, (0, _preact.h)("div", {
    className: "event__month"
  }, (0, _preact.h)("span", null, month)), (0, _preact.h)("div", {
    className: "event__date"
  }, day))), (0, _preact.h)("div", {
    className: "event-detail-container"
  }, type && (0, _preact.h)("div", {
    className: "event__type"
  }, type), (0, _preact.h)("span", {
    className: "event__title qa-event-title"
  }, title))));
};

var _default = EventCalendarRow;
exports.default = _default;